<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.7305 5.10671C17.7305 2.65757 15.7489 0.672119 13.2969 0.672119C10.7147 0.672119 7.30186 0.672119 4.7197 0.672119C2.26766 0.672119 0.286011 2.65757 0.286011 5.10671C0.286011 6.71005 0.286011 8.5726 0.286011 10.1769C0.286011 11.3529 0.746394 12.4809 1.57709 13.3126C2.40778 14.1442 3.53872 14.6116 4.7197 14.6116H5.60044C5.60044 15.4143 5.60044 16.7074 5.60044 16.7074C5.60044 16.9456 5.73055 17.1628 5.94072 17.2688C6.1609 17.3739 6.41111 17.3479 6.60127 17.2028L9.97408 14.6116H13.2969C14.4778 14.6116 15.5988 14.1442 16.4295 13.3126C17.2702 12.4809 17.7305 11.3529 17.7305 10.1769V5.10671ZM12.4762 8.16326H5.13005C4.78976 8.16326 4.50953 8.4435 4.50953 8.78878C4.50953 9.13407 4.78976 9.4143 5.13005 9.4143H12.4762C12.8265 9.4143 13.1067 9.13407 13.1067 8.78878C13.1067 8.4435 12.8265 8.16326 12.4762 8.16326ZM9.41362 5.44199H5.13005C4.78976 5.44199 4.50953 5.72222 4.50953 6.06751C4.50953 6.4118 4.78976 6.69303 5.13005 6.69303H9.41362C9.76391 6.69303 10.0441 6.4118 10.0441 6.06751C10.0441 5.72222 9.76391 5.44199 9.41362 5.44199Z"
      fill="#3CA091"
    />
  </svg>
</template>

<script>
export default {
  name: 'QuestionSelected'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
